var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6004 11.9999C21.6004 14.546 20.589 16.9878 18.7886 18.7881C16.9883 20.5885 14.5465 21.5999 12.0004 21.5999C9.45431 21.5999 7.01252 20.5885 5.21217 18.7881C3.41182 16.9878 2.40039 14.546 2.40039 11.9999C2.40039 9.45382 3.41182 7.01203 5.21217 5.21168C7.01252 3.41133 9.45431 2.3999 12.0004 2.3999C14.5465 2.3999 16.9883 3.41133 18.7886 5.21168C20.589 7.01203 21.6004 9.45382 21.6004 11.9999ZM13.2004 16.7999C13.2004 17.1182 13.074 17.4234 12.8489 17.6484C12.6239 17.8735 12.3187 17.9999 12.0004 17.9999C11.6821 17.9999 11.3769 17.8735 11.1519 17.6484C10.9268 17.4234 10.8004 17.1182 10.8004 16.7999C10.8004 16.4816 10.9268 16.1764 11.1519 15.9514C11.3769 15.7263 11.6821 15.5999 12.0004 15.5999C12.3187 15.5999 12.6239 15.7263 12.8489 15.9514C13.074 16.1764 13.2004 16.4816 13.2004 16.7999ZM12.0004 5.9999C11.6821 5.9999 11.3769 6.12633 11.1519 6.35137C10.9268 6.57642 10.8004 6.88164 10.8004 7.1999V11.9999C10.8004 12.3182 10.9268 12.6234 11.1519 12.8484C11.3769 13.0735 11.6821 13.1999 12.0004 13.1999C12.3187 13.1999 12.6239 13.0735 12.8489 12.8484C13.074 12.6234 13.2004 12.3182 13.2004 11.9999V7.1999C13.2004 6.88164 13.074 6.57642 12.8489 6.35137C12.6239 6.12633 12.3187 5.9999 12.0004 5.9999Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.4646ac10c3537ed89128882f8ac3827e.svg";
export { ForwardRef as ReactComponent };